module.exports = __webpack_public_path__ + "img/szk.0f189909.png";